var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDropbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65116 1L0 4.01395L3.23721 6.6186L7.88837 3.71628L4.65116 1ZM0 9.14884L4.65116 12.2L7.88837 9.48372L3.23721 6.6186L0 9.14884ZM7.88837 9.48372L11.1628 12.2L15.7767 9.18605L12.5767 6.6186L7.88837 9.48372ZM15.7767 4.01395L11.1628 1L7.88837 3.71628L12.5767 6.6186L15.7767 4.01395ZM7.92558 10.0791L4.65116 12.7953L3.27442 11.8651V12.907L7.92558 15.6977L12.5767 12.907V11.8651L11.1628 12.7953L7.92558 10.0791Z",
    fill: "#007EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropbox);
export default __webpack_public_path__ + "static/media/icon-dropbox.cf6c93cbc7210729ac11db8fb80fffc1.svg";
export { ForwardRef as ReactComponent };